/* Product page purchase CTA (12 Oct 2026).
   Keeps the Buy now / enquiry state in step with the theme's own add-to-cart
   submit button, which Dawn updates on variant change (disabled attribute and
   label text). Enquiry state = submit disabled AND a non "Add to cart" label
   present (Made-to-order enquiry / Unavailable). A disabled submit that still
   reads "Add to cart" is just Dawn's in-flight variant fetch, not an enquiry. */
(() => {
  const addLabel = () => (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';

  const sync = (wrap) => {
    const submit = wrap.querySelector('[name="add"]');
    if (!submit) return;
    const labels = [...submit.querySelectorAll(':scope > span')]
      .map((span) => span.textContent.trim())
      .filter(Boolean);
    if (!labels.length) labels.push(submit.textContent.trim());
    const enquiry = submit.disabled && labels.some((text) => text !== addLabel());
    wrap.classList.toggle('ak-pdp-buy--enquiry', enquiry);
    const buy = wrap.querySelector('[data-ak-buy-now]');
    if (buy) buy.disabled = enquiry;
  };

  const watch = (wrap) => {
    if (wrap.dataset.akCtaWatched) return;
    wrap.dataset.akCtaWatched = 'true';
    sync(wrap);
    const submit = wrap.querySelector('[name="add"]');
    if (!submit) return;
    new MutationObserver(() => sync(wrap)).observe(submit, {
      attributes: true,
      attributeFilter: ['disabled'],
      childList: true,
      subtree: true,
      characterData: true,
    });
  };

  const start = () => document.querySelectorAll('.ak-pdp-buy').forEach(watch);
  start();
  document.addEventListener('shopify:section:load', start);
})();
